import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
    //authorization: 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }
  private _loginUrl = environment.local+'customers/loginuser';
  private _loginCandidate = environment.local+'customers/logincandidate';
  private _registerCandidate = environment.local+'customers/registercandidate';
  private _loggedinUrl = environment.local+'customers/loggedin';


  loggedIn(userCredentials) {
    return this.http.post<boolean>(this._loggedinUrl, userCredentials, httpOptions)
  }

  loginUser(userCredentials) {
    return this.http.post<any>(this._loginUrl, userCredentials, httpOptions)
  }

  loginCandidate(userCredentials){
    return this.http.post<any>(this._loginCandidate, userCredentials, httpOptions)
  }

  registerCandidate(userCredentials){
    return this.http.post<any>(this._registerCandidate, userCredentials, httpOptions)
  }

}
